import PATH from "constants/path";

export const whiteListHeader = [PATH.home, PATH.lottery, PATH.affiliate];
export const listCheckAffiliate = [PATH.affiliate];
